export const SEGMENT_TYPES_REQUEST = '@@segments/SEGMENT_TYPES_REQUEST';
export const SEGMENT_TYPES_SUCCESS = '@@segments/SEGMENT_TYPES_SUCCESS';
export const SEGMENT_TYPES_FAILURE = '@@segments/SEGMENT_TYPES_FAILURE';

export const SEGMENTS_REQUEST = '@@segments/SEGMENTS_REQUEST';
export const SEGMENTS_SUCCESS = '@@segments/SEGMENTS_SUCCESS';
export const SEGMENTS_FAILURE = '@@segments/SEGMENTS_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/segments/types.js